(() => {
  async function copyTextToClipboard(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(text);
      return;
    }

    const input = document.createElement('textarea');
    input.value = text;
    input.setAttribute('readonly', '');
    input.style.cssText = 'position:fixed;left:-9999px;top:0;opacity:0;';
    document.body.appendChild(input);
    input.focus();
    input.select();
    document.execCommand('copy');
    document.body.removeChild(input);
  }

  async function handleCmsCopyClick(event) {
    const btn = event.target.closest('[data-cms-copy-btn]');
    if (!btn) return;

    event.preventDefault();
    event.stopPropagation();

    const value = String(btn.getAttribute('data-copy-text') || '').trim();
    if (!value) return;

    try {
      await copyTextToClipboard(value);
      window.alert(btn.getAttribute('data-copy-tip') || '已复制');
    } catch (error) {
      console.warn('[cms-copy] copy failed', error);
    }
  }

  if (!window.__cmsCopyClickBound) {
    window.__cmsCopyClickBound = true;
    // capture: parent Alpine @click.stop must not block this
    document.addEventListener('click', handleCmsCopyClick, true);
  }

  function register() {
    if (!window.Alpine || window.__stepsEnvelopePopupRegistered) return;
    window.__stepsEnvelopePopupRegistered = true;

    Alpine.data('stepsEnvelopePopup', (totalSteps = 1) => ({
      totalSteps: Math.max(1, Math.min(4, Number(totalSteps) || 1)),
      currentStep: 0,
      dismissed: false,

      open() {
        if (this.dismissed || this.totalSteps < 2) return;
        this.currentStep = 1;
        document.body.classList.add('overflow-hidden');
      },

      next() {
        if (this.currentStep < this.totalSteps - 1) {
          this.currentStep += 1;
          return;
        }
        this.close();
      },

      close() {
        this.currentStep = 0;
        document.body.classList.remove('overflow-hidden');
      },

      dismiss() {
        this.close();
        this.dismissed = true;
      },
    }));
  }

  if (window.Alpine) {
    register();
  } else {
    document.addEventListener('alpine:init', register);
  }
})();
